import { Model } from "../mvvm/Model.js";
/** Public kitchen-ticket status (number + status only; no customer PII). */
export class PublicOrderTicket extends Model {
    orderNumber;
    status;
    constructor(orderNumber, status) {
        super();
        this.orderNumber = orderNumber;
        this.status = status;
    }
    number() {
        return this.orderNumber;
    }
    statusKey() {
        return this.status;
    }
    headline() {
        switch (this.status) {
            case "received":
                return "We have your order";
            case "printed":
                return "The kitchen is preparing your order";
            case "done":
                return "Your order is ready";
            case "refunded":
                return "This order was refunded";
            default:
                return "We found your order";
        }
    }
    detail() {
        switch (this.status) {
            case "received":
                return "The restaurant has your ticket and will start preparing it soon.";
            case "printed":
                return "The kitchen has your ticket and is preparing your order now.";
            case "done":
                return "Please come to the counter when you are ready to pick it up.";
            case "refunded":
                return "If you have questions about this refund, please speak with the restaurant.";
            default:
                return "Check back shortly for the next update on your order.";
        }
    }
    validate() {
        const errors = [];
        if (!Number.isFinite(this.orderNumber) || this.orderNumber < 1) {
            errors.push("Order number is required.");
        }
        return errors;
    }
}
//# sourceMappingURL=PublicOrderTicket.js.map